var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.96 53.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m26.98,53.96C12.1,53.96,0,41.86,0,26.98S12.1,0,26.98,0s26.98,12.1,26.98,26.98-12.1,26.98-26.98,26.98Zm0-43.47c-9.09,0-16.48,7.4-16.48,16.48s7.4,16.49,16.48,16.49,16.48-7.4,16.48-16.49-7.4-16.48-16.48-16.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco);
export default __webpack_public_path__ + "static/media/ico.4afdc4da3c1b1e14d624f2d15c98488b.svg";
export { ForwardRef as ReactComponent };